// #714, Session 79.22b.4.3.1 -- AN ITEM IS NAMED, OR SAYS IT IS STILL COMING.
//
// The Transfers page fetches its list, then every item's name in a second
// query. A transfer opened from a bell draws the moment the list lands, so it
// read "Item 26" where Coroplast 4mm 4x8 belonged until the names arrived.
// The map the page builds carries a mark saying the names have been fetched;
// before it does, a missing name is "…", never a database number. After it, a
// name still missing is shown as the number -- the honest last resort.
const NAMES_FETCHED = Symbol('namesFetched');

export function namedItems(rows) {
  const map = Object.fromEntries((rows || []).map(i => [String(i.id), i]));
  map[NAMES_FETCHED] = true;
  return map;
}

export function itemLabel(items, itemId) {
  const name = items?.[String(itemId)]?.name;
  if (name) return name;
  return items?.[NAMES_FETCHED] ? `Item ${itemId}` : '…';
}
